/** Códigos de error (400) de los 3 endpoints de recuperación de contraseña.
 *  Mismo shape `{ success, code, message }` que los del wizard de finca, pero
 *  con su propio juego de códigos — de ahí el parser dedicado en vez de reusar
 *  `parseWizardError`. */
export type PasswordResetErrorCode =
  /** Paso 1: el email no tiene formato válido. */
  | "EMAIL_INVALIDO"
  /** Paso 2: el código no coincide (se puede reintentar). */
  | "CODIGO_INVALIDO"
  /** Paso 2: el código venció (hay que pedir uno nuevo). */
  | "CODIGO_EXPIRADO"
  /** Paso 2: se agotaron los intentos (hay que pedir uno nuevo). */
  | "CODIGO_BLOQUEADO"
  /** Paso 3: el `resetToken` no existe o ya se usó. */
  | "TOKEN_INVALIDO"
  /** Paso 3: el `resetToken` venció. */
  | "TOKEN_EXPIRADO"
  /** Paso 3: la contraseña no cumple la política del servidor. */
  | "PASSWORD_DEBIL";

export type PasswordResetErrorResponse = {
  success: false;
  code: PasswordResetErrorCode;
  message: string;
};

/** Parsea el mensaje de error de `olvide`/`verificar-codigo`/`restablecer`
 *  (gRPC-Web, ver `mapPasswordResetGrpcError`). Devuelve la respuesta completa
 *  si tiene la forma `{ success, code, message }`, o `null` si no (error de
 *  red, 500, texto plano). **Ramificar siempre por `code`, nunca por
 *  `message`.** */
export function parsePasswordResetError(
  error: unknown,
): PasswordResetErrorResponse | null {
  if (!(error instanceof Error)) return null;
  try {
    const parsed = JSON.parse(
      error.message,
    ) as Partial<PasswordResetErrorResponse>;
    if (typeof parsed.message === "string" && typeof parsed.code === "string") {
      return parsed as PasswordResetErrorResponse;
    }
  } catch {
    // no-op — no era JSON.
  }
  return null;
}

/** Texto mostrable de un error que `parsePasswordResetError` no supo ramificar
 *  (red caída, 500, body en texto plano). Para los 400 con `code`, usar el
 *  `message` de la respuesta parseada. */
export function passwordResetErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  return String(error);
}
